import {StyleSheet} from 'react-native';

import {cloudLight, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  groupLabelText: {
    marginBottom: 6,
  },
  groupItems: {
    backgroundColor: white,
  },
  groupItemWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  groupItemText: {
    lineHeight: 24,
  },
});
